import React from 'react';
import { Component } from '../../../concepts/objects';
import { Matrix } from '../../../platform/geom/Matrix';
import { Rect } from '../../../platform/geom/Rect';
import { PropertyStripLayout } from '../properties/PropertyStripLayout';
import { Physical } from './Physical';
import { TextSettings } from './TextConventions';

export interface UIFieldProps {
    active?: boolean;
    field: UIField;
}

export interface UIFieldType {
    readonly name: string;
    readonly ui: React.ComponentType<UIFieldProps>;
}

export const UIFieldType = (type: UIFieldType) => type;

export interface UIField {
    readonly ui: React.ComponentType<UIFieldProps>;
    readonly name: string;
    readonly bounds: Rect;
    readonly owner: Component;
    readonly offset?: Matrix;
    readonly propertyLayout?: PropertyStripLayout<Physical>;
}

export const UIField = {
    key(field: UIField) {
        return `edit:${field.owner.id}`;
    }
};

export interface TextUIField extends UIField {

    readonly settings: TextSettings;

    readonly maxLength: number;

    value: string;
}
